import { i18n, Resource } from 'i18next';
import { useLocale } from '@tanium/react-locale-context';
import { generateTrans } from './generateTrans';
import { generateUseTranslation } from './generateUseTranslation';
import { getCalculatedLocale } from './getCalculatedLocale';
import { i18nFactory } from './i18nFactory';

export const generateTranslationTools = (packageName: string, resources: Resource) => {
  // This state is stored here, outside a react component, the first time an @tanium package is used.
  // That way, we have 'global space per package', so i18n can create/init only once per package.
  const i18nInstance: i18n = i18nFactory(packageName, resources);

  const useTranslation = generateUseTranslation(i18nInstance, packageName, resources);
  const Trans = generateTrans(i18nInstance, useTranslation);
  const useCalculatedWorkbenchLocale = () => getCalculatedLocale(resources, useLocale());

  return {
    Trans,
    useTranslation,
    useCalculatedWorkbenchLocale,
  };
};
